import { render, staticRenderFns } from "./EmployeeCompanyAsset.vue?vue&type=template&id=2e8b7a71"
import script from "./EmployeeCompanyAsset.vue?vue&type=script&lang=js"
export * from "./EmployeeCompanyAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports